/* eslint react/prop-types: 0 */

import React from "react";
import ChartBar from "../../component/ChartBar";
import FormFilterKinerja from "./FormFilterKinerja";
import BarChartKinerja from "./BarChartKinerja";

export const TrenKinerja = () => {
  return (
    <div className="card container py-3 border-0 h-100 ">
      <h3>Tren Kinerja</h3>
      <FormFilterKinerja />
      <div style={{ maxHeight: "30%" }}>
        <BarChartKinerja />
      </div>
    </div>
  );
};
